import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import queryClient from './lib/queryClient.js';
import { registerServiceWorker } from './lib/registerServiceWorker.js';
import { PeriodProvider } from './hooks/usePeriod.jsx';
import App from './App.jsx';
import './styles/index.css';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <PeriodProvider>
          <App />
        </PeriodProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </StrictMode>
);

registerServiceWorker();
